import SvgIcon from '../../../SvgIcon/index';
import {
  StyledUserMenuRow,
  StyledUserMenuTitle,
} from './user-menu-link-item.styled';

type UserMenuLinkItemProps = {
  title: string,
  link: string,
  Icon: React.FC,
  target?: '_blank' | '_self' | '_parent' | '_top',
}

function UserMenuLinkItem({
  title,
  link,
  Icon,
  target,
}: UserMenuLinkItemProps): JSX.Element {
  const rel = target === '_blank' ? 'noopener noreferrer' : undefined;

  return (
    <StyledUserMenuRow href={ link } target={ target } rel={ rel }>
      <SvgIcon Icon={ Icon } size="small" />
      <StyledUserMenuTitle>
        { title }
      </StyledUserMenuTitle>
    </StyledUserMenuRow>
  );
}

UserMenuLinkItem.defaultProps = {
  target: '_self',
};

export default UserMenuLinkItem;
